export class Unloaded {
  readonly _type = "unloaded";
}

export class UnloadedListItem extends Unloaded {
  constructor(public id: string | number) {
    super();
  }
}
